import { memo } from "react";
import { UI_ScreenStyles } from "../UI_ScreenStyles";
import { createBreadcrumbItems, commonBreadcrumbs } from "~/utils/breadcrumbUtils";

const SettingScreen = () => {
  return (
    <UI_ScreenStyles.UI_Wrapper>
      <UI_ScreenStyles.UI_Breadcrumb
        items={createBreadcrumbItems([
          commonBreadcrumbs.home,
          { title: 'Cài đặt', icon: commonBreadcrumbs.settings.icon }
        ])}
      />

      <UI_ScreenStyles.UI_Content_Wrapper>
        <div>
          Màn hình cài đặt
        </div>
      </UI_ScreenStyles.UI_Content_Wrapper>
    </UI_ScreenStyles.UI_Wrapper>
  )
}

export default memo(SettingScreen);